function hasNoPayload(payload) {
  return payload === undefined || payload === null || typeof payload !== 'object';
}

export default function hasPayloadAndResourcesAreLinked(state, action) {
  const { payload } = action;
  return !hasNoPayload(payload);
}
